import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { IPopupState } from '../../interfaces/popup.interface';

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  private popupSubject: Subject<IPopupState> = new Subject<IPopupState>();
  popupState: Observable<IPopupState>;
  continueFlow: boolean;
  isRedirecting: boolean;
  continueWithFirmlyApproved: boolean;

  constructor() {
    this.popupState = this.popupSubject.asObservable();
    this.continueFlow = false;
    this.isRedirecting = false;
    this.continueWithFirmlyApproved = false;
  }

  showPopup() {
    this.popupSubject.next({ showPopup: true } as IPopupState);
  }

  hidePopup(continueFlow: boolean, isRedirecting: boolean = false) {
    this.popupSubject.next({
      showPopup: false,
      continueFlow,
      isRedirecting,
    } as IPopupState);
  }
}
